import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from '../app/App';
import {
	PROGRAMS,
	ERROR,
	SESSION_EXPIRED,
	INDEX,
	TEMPLATES,
	REVIEWS,
	INVITATIONS,
	ORGANIZATION
} from '../constants/routes';
import Error404 from '../pages/Error404';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';
import NoApplicantProtection from '../components/ProtectedRoute/NoApplicantProtection';
import Programs from '../pages/Programs/Programs';
import { IndividualProgram } from '../pages/IndividualProgram';
import Templates from '../pages/Templates/Templates';
import UserReviews from '../pages/UserReviews/UserReviews';
import UserInvitations from '../pages/UserInvitations/UserInvitations';
import SessionExpired from '../pages/SessionExpired';
import Organization from '../pages/Organization/Organization';
import RestrictedRoute from './RestrictedRoute';
import { AUDITOR_ACCOUNT_TYPE } from '../constants/common';

const router = createBrowserRouter([
	{
		// PAGES ROUTES WITHOUT LAYOUT
		path: ERROR,
		element: <Error404 />
	},
	{
		path: SESSION_EXPIRED,
		element: <SessionExpired />
	},
	// PAGES ROUTES WITH LAYOUT and FUTURE AUTH PROTECTION
	{
		path: INDEX,
		element: <ProtectedRoute component={App} />,
		children: [
			{
				path: INDEX,
				element: <NoApplicantProtection component={Programs} />
			},
			{
				path: PROGRAMS,
				children: [
					{
						index: true,
						element: <NoApplicantProtection component={Programs} />
					},
					{
						path: ':programID/overview',
						element: <NoApplicantProtection component={IndividualProgram} />
					},
					{
						path: ':programID/applications/',
						element: <IndividualProgram />
					},
					{
						path: ':programID/applications/:appID/*',
						element: <IndividualProgram />
					},
					{
						path: ':programID/reviews/:reviewID/*',
						element: <NoApplicantProtection component={IndividualProgram} />
					},
					{
						path: ':programID/application-setup/*',
						element: <NoApplicantProtection component={IndividualProgram} />
					}
				]
			},
			{
				path: ORGANIZATION,
				element: (
					<RestrictedRoute redirectPath={PROGRAMS} excludedUsers={[AUDITOR_ACCOUNT_TYPE]}>
						<Organization />
					</RestrictedRoute>
				)
			},
			{
				path: REVIEWS,
				element: <UserReviews />
			},
			{
				path: INVITATIONS,
				element: <UserInvitations />
			},
			{
				path: TEMPLATES,
				element: <NoApplicantProtection component={Templates} />
			}
		]
	}
]);

export default function RouterApp(): JSX.Element {
	return <RouterProvider router={router} />;
}
